import React, { useState } from 'react';
import "./PopupComponent.css"
import moment from "moment";

const PopupComponent = () => {
    const [showModal, setShowModal] = useState(false);

    if(moment().month() <= 3 && !localStorage.getItem("authToken") && !localStorage.getItem("is_closed_n",'Y')){
        setTimeout(function(){
            setShowModal(true);
        },1000)
    }
    const toggleModal = () => {
        setShowModal(!showModal);
        localStorage.setItem("is_closed_n",'Y');
    };

    return (
        <>
            {showModal && (

<div className="modal fade show" id="staticBackdrop" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true" style={{ display: 'block',"z-index":"9999"}}>
<div className="modal-dialog modal-lg">
    <div className="modal-content">
        <div className="modal-body">
            <div className="text-right"> <i className="fa fa-close close" onClick={toggleModal} data-dismiss="modal"></i> </div>
            <div className="row">
                <div className="col-md-6">
                    <div className="text-center mt-2">
                        <img src="https://i.imgur.com/3dG6dJo.jpg" width="200" alt="Premium" />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="text-white mt-5">
                        <h1 className="mb-0">Limited-Time Offer</h1>
                        <span className="intro-1">Double your value, pay half the price!</span>
                        <div className="mt-4">
                            <span className="intro-2">Sign up before April 30th 2024 and get two months' access for the price of one</span>
                        </div>
                        <div className="mt-4 mb-5">
                            <a href="/user_registration" className="btn btn-primary" style={{"backgroundColor":"#00e1ba"}}>Yes Please <i className="fa fa-long-arrow-right"></i></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</div>

            )}
            {showModal && <div className="modal-backdrop fade show"></div>}
        </>
    );
};

export default PopupComponent;